import React from "react";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import type { KCloudIntegrationInfo } from "@/features/accounts/account-group/hooks/use-kcloud-integration";

interface Props {
  checkboxId: string;
  serviceName: string;
  isIntegrated: boolean;
  isOtherServiceIntegrated: boolean;
  serviceIntegrationInfo: KCloudIntegrationInfo | null;
  onConnect: () => void;
  onDisconnect: () => void;
}

export const KCloudIntegrationField = ({
  checkboxId,
  serviceName,
  isIntegrated,
  isOtherServiceIntegrated,
  serviceIntegrationInfo,
  onConnect,
  onDisconnect,
}: Props) => {
  return (
    <>
      <input 
        type="checkbox" 
        id={checkboxId} 
        name={checkboxId} 
        checked={isIntegrated}
        readOnly
      />
      <dl>
        <dt>
          <strong>{serviceName}</strong>
          {!isIntegrated ? (
            <BaseRoundButton
              buttonText="連携情報の設定"
              onClick={onConnect}
              isActive={!isOtherServiceIntegrated}
            />
          ) : (
            <label
              htmlFor={checkboxId}
              onClick={onDisconnect}
            >
              連携解除
            </label>
          )}
        </dt>
        {isIntegrated && serviceIntegrationInfo && (
          <dd>
            <strong>{serviceIntegrationInfo.serviceType == 1 ? '顧問先コード' : '事業所コード'}: {serviceIntegrationInfo.clientCode || "未設定"}</strong>
            <span>{serviceIntegrationInfo.serviceType == 1 ? `利用者ID` : `ID`}: {serviceIntegrationInfo.userId || "未設定"}</span>
          </dd>
        )}
      </dl>
    </>
  );
};
